<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#0B9E65" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M10.6519 16.0254L6.59998 12.071L7.90242 10.8003L10.5994 13.4317L16.0469 7.67993L17.4 8.89949L10.6519 16.0254Z"
    fill="white" />
</svg>